// extracted by mini-css-extract-plugin
module.exports = {"container":"FormLabel_container__1_F7Z","label":"FormLabel_label__2TMUP","description":"FormLabel_description__GgTOb","control":"FormLabel_control__2pv45"};